var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("input", {
    directives: [
      {
        name: "validate",
        rawName: "v-validate",
        value: _vm.validation,
        expression: "validation"
      }
    ],
    ref: "ref",
    staticClass: "form-control",
    class: _vm.inputclass,
    attrs: { type: "text", name: _vm.name, readonly: _vm.readonly },
    domProps: { value: _vm.value },
    on: {
      input: function($event) {
        return _vm.$emit("input", $event.target.value)
      },
      keyup: function($event) {
        if (
          !$event.type.indexOf("key") &&
          _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
        ) {
          return null
        }
        return _vm.$emit("keyupenter", $event)
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }